import request from "./axios";

export function login(data) {
  return request({ method: "post", url: "/Login/Login1", data });
}
export function login_phone(data) {
  return request({ method: "post", url: "/Login/GetCode", data });
}
export function phone_login(data) {
  return request({ method: "post", url: "/Login/Login2", data });
}
export function account_list(data) {
  return request({ method: "post", url: "/Login/Getlist", data });
}
export function accountLoginChose(data) {
  return request({ method: "post", url: "/Login/Jump", data });
}
// export function test() {
//   return request({ method: "get", url: "/Login/GetUrl" });
// }
